
define('text!views/map/name_infowindow.html',[],function () { return '<div class="map-name-infowindow-name"><%- this.name %></div>';});

